module.exports = __webpack_public_path__ + "static/media/Avenir-Black.65d61b25.woff";